import useAuthUtilities from '@/AuthMiddleware/AuthUtilities';
import { projectServiceApiClient } from '@/clients/ProjectServiceApiClient';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import useAlbumId from './useAlbumId';
import { ProjectDto } from '@/data/models/projectsService';

export const getProjectByAlbumIdQueryKey = 'project' as const;

export default function useGetProjectQuery(): UseQueryResult<
  ProjectDto | null,
  Error
> {
  const albumId = useAlbumId();
  const { canUserReadProjectService } = useAuthUtilities();

  async function queryFn() {
    const response =
      await projectServiceApiClient.getProjectByPrsProduct(albumId);

    return response?.data?.at(0) ?? null;
  }

  return useQuery({
    queryFn,
    enabled: canUserReadProjectService(),
    queryKey: [getProjectByAlbumIdQueryKey],
    staleTime: 10000,
  });
}
